import { InvoicesColumns } from "./columns";
import { z } from "zod";
import { LineItemSchema } from "@/types/schemas/line_items";

export const INVOICE_STATUSES = ["DRAFT", "SENT", "PAID", "OVERDUE", "CANCELLED"] as const;

export const INVOICE_TERMS = ["Net 10", "Net 30", "Net 60"] as const;
export type InvoiceTermsType = (typeof INVOICE_TERMS)[number];

export const InvoiceStatusSchema = z.enum(INVOICE_STATUSES).default("DRAFT");

export type InvoiceStatusType = z.infer<typeof InvoiceStatusSchema>;

export const InvoiceMetaSchema = z.object({
  invoice_number: z.string().optional(),
  invoice_date: z.date().optional(),
  purchase_order_number: z.string().optional(),
  amount_due: z.number().optional(),
  terms: z.string().optional(),
  remittance_address_id: z.string().optional(),
  line_items: z.array(LineItemSchema).default([]),
  status: InvoiceStatusSchema,
  combine_admin_fee: z.boolean().optional(),
  combine_discount: z.boolean().optional(),
  deposit_applied: z.number().optional(),
});

export type InvoiceMeta = z.infer<typeof InvoiceMetaSchema>;

// Line item type for extracted fields
export type LineItem = {
  description: string;
  unit_price: number;
  quantity: number;
  amount: number;
  time_in?: string;
  time_out?: string;
  admin_fee?: number;
  discount?: number;
};

// Extended type that includes both nested meta_data and extracted fields
export type InvoiceType = Omit<InvoicesColumns, "meta_data"> & {
  meta_data: InvoiceMeta;
  // Extracted fields from meta_data (populated by service layer)
  invoice_number?: string;
  invoice_date?: string;
  purchase_order_number?: string;
  amount_due?: number;
  line_items?: LineItem[];
  // Joined relations (populated by service layer)
  project?: {
    id: string;
    name: string;
    client_id?: string;
    meta_data?: { deposit_amount?: number | null; [key: string]: any };
    client?: {
      id: string;
      name: string;
      meta_data?: import("./clients").ClientMetaType;
    };
  };
};
